import React from 'react';
import { Styles } from './style';
import LogoElitePrime from '@assets/images/Logotipo/Elite Prime_Logo_FundoPreto.png';
import { Link } from 'react-router-dom';

interface RightsProps {
  nomeEmpresa?: string;
  logoUri?: string;
  creci?: string;
}

const Rights: React.FC<RightsProps> = ({
  nomeEmpresa = 'Imobiliária Elite Prime',
  logoUri,
  creci
}) => {
  return (
    <Styles.RightsContainer>
      <Link
        to={`/home`}
        style={{
          textDecoration: 'none',
          color: 'inherit',
          alignItems: 'flex-end',
          display: 'flex'
        }}>
        <Styles.LogoContainer>
          <Styles.LogoImg src={logoUri || LogoElitePrime} />
        </Styles.LogoContainer>
      </Link>
      <Styles.RightsText>
        Todos os Direitos Reservados à {nomeEmpresa}
      </Styles.RightsText>
      {creci && <Styles.RightsText>CRECI: {creci}</Styles.RightsText>}
    </Styles.RightsContainer>
  );
};

export default Rights;
